import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class SaleService {

  
constructor(
            private http: HttpClient, 
            private global: GlobalDataService
           ) { } 

   getSale(page: number = 0) {
        let url = "";
        if(page){
          url = "?page="+page;
        }
        return this.http.get(this.global.httpUrl+"sales"+url);
   }

   
   getSaleById(id: string) {
    return this.http.get(this.global.httpUrl+"sales/"+id);
}

   getSaleByFilter(filter: any[],page:number = 0) {
    let url = "";
    if(page){
      url = "page="+page + "&";
    }
    if(filter){
      for (var item of filter) {
        url += item.name + "=" + item.value + "&";
     }
    }
    
    url = url.substring(0,url.length-1);

    return this.http.get(this.global.httpUrl + "sales?" + url);
 }

   saleChanging(saleId: string,isChanging: boolean){
    return this.http.post(this.global.httpUrl+"sales/changing-row", {sale_id: saleId,changing: isChanging });
   }  
 
   issueSale(data: any){
      return this.http.post(this.global.httpUrl+"sales", data);
   } 
   updateSale(data: any,saleId: any){
    return this.http.put(this.global.httpUrl+"sales/"+saleId, data);
   } 
   applyAcceptedSale(data: any){
    return this.http.post(this.global.httpUrl+"sales/apply-status-accepted", data);
   } 
   applyInprocessingSale(data: any){
    return this.http.post(this.global.httpUrl+"sales/apply-status-inprocessing", data);
   } 

   applyFinishSale(data: any){
    return this.http.post(this.global.httpUrl+"sales/apply-status-finished", data);
   }

   printSale(id: any){
      return this.http.get(this.global.httpUrl+"sales/print/"+id);
   }
   printSaleReview(id: any){
    return this.http.get(this.global.httpUrl+"sales/print/summary/"+id);
  }

   getSaleItemListByIdService(id: any) {
        return this.http.get(this.global.httpUrl+"sales/items?sale_id="+id);
   }

   
   getSoldStatistic(data: any) {
    return this.http.post(this.global.httpUrl+"reports/sold-statistic",data);
}

   refundProductService(data: any) {
        return this.http.post(this.global.httpUrl+"sales/items/"+data['sale_item_id']+"/refund",data);
   }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/sales/sale.service.ts